"use client";

import React from "react";
import { siteConfig } from "@/config/site";
import { trackAffiliateClick } from "@/lib/analytics";

interface AffiliateLinkProps {
  source: string;
  className?: string;
  children: React.ReactNode;
}

export default function AffiliateLink({ source, className, children }: AffiliateLinkProps) {
  return (
    <a
      data-agent-ignore
      href={`${siteConfig.links.affiliate}?source=${encodeURIComponent(source)}`}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackAffiliateClick(source)}
    >
      {children}
    </a>
  );
}
